module.exports = __webpack_public_path__ + "static/img/mission-bg.3be9a6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/introduce/mission-bg.jpg
// module id = zugS
// module chunks = 1